module.exports = __webpack_public_path__ + "img/onboarding-step-6.391e0cd4.png";